import React, { useState, useMemo, useEffect } from 'react';
import { connect, useIntl } from 'umi';
import { Collapse, Segment } from 'tea-component';
import SvgIcon from '@/pages/home/components/SvgIcon';
import GameList from './GameList';

import './GameTypeFilter.scss';

function GameTypeFilter(props: any) {
  const { gameList, searchValue = '', setGameModalVisible, namespace, menuWidth } = props;
  const { formatMessage } = useIntl();
  const [gameType, setGameType] = useState('all');
  const [activeIds, setActiveIds] = useState<Array<string>>([]);
  const { pcGame, mobileGame, consoleGame, renderGameList, renderNoAccessGameList } =
    useMemo(() => {
      const mobileGame: any[] = [];
      const pcGame: any[] = [];
      const consoleGame: any[] = [];
      const accessGame: any[] = [];
      const noAccessGame: any[] = [];
      let renderGameList: any[] = [];
      let renderNoAccessGameList: any[] = [];

      gameList?.forEach((game: any) => {
        if (game.is_access) {
          accessGame.push(game);
        } else {
          noAccessGame.push(game);
        }
        // 和产品王婕沟通后：
        // 如果游戏类型同时是mobile、pc、console则按照pc处理
        // 如果游戏类型同时是mobile、console则按照mobile处理
        // 如果游戏类型同时是mobile、pc则按照pc处理
        // 如果游戏类型同时是pc、console则按照pc处理
        if (game.game_type?.includes('mobile') && !game.game_type?.includes('pc'))
          mobileGame.push({ ...game, game_type: 'mobile' });
        if (game.game_type?.includes('pc')) pcGame.push({ ...game, game_type: 'pc' });
        if (game.game_type === 'console') consoleGame.push({ ...game, game_type: 'console' });
      });

      // 根据筛选条件过滤
      switch (true) {
        case gameType === 'all': {
          renderGameList = gameList?.filter((item: { is_access: any; }) => item?.is_access);
          renderNoAccessGameList = gameList?.filter((item: { is_access: any; }) => !item?.is_access);
          break;
        }
        case gameType === 'pc': {
          renderGameList = pcGame?.filter((item: { is_access: any; }) => item?.is_access);
          renderNoAccessGameList = pcGame?.filter((item: { is_access: any; }) => !item?.is_access);
          break;
        }
        case gameType === 'mobile': {
          renderGameList = mobileGame?.filter((item: { is_access: any; }) => item?.is_access);
          renderNoAccessGameList = mobileGame?.filter((item: { is_access: any; }) => !item?.is_access);
          break;
        }
        case gameType === 'console': {
          renderGameList = consoleGame?.filter((item: { is_access: any; }) => item?.is_access);
          renderNoAccessGameList = consoleGame?.filter((item: { is_access: any; }) => !item?.is_access);
          break;
        }
      }

      return {
        pcGame,
        mobileGame,
        consoleGame,
        accessGame,
        noAccessGame,
        renderGameList,
        renderNoAccessGameList,
      };
    }, [gameType, gameList]);

  // #region 筛选 tab
  const gameTypeList = [
    { text: formatMessage({ id: 'game_selector_all_tab' }), value: 'all' },
    {
      text: (
        <>
          <SvgIcon className="all-game-icon" type="other-icon" />
          {mobileGame?.length ?? 0}
        </>
      ),
      icon: 'other-icon',
      value: 'mobile',
    },
    {
      text: (
        <>
          <SvgIcon className="all-game-icon" type="monitor" />
          {pcGame?.length ?? 0}
        </>
      ),
      icon: 'monitor',
      value: 'pc',
    },
    {
      text: (
        <>
          <SvgIcon className="all-game-icon" type="game" />
          {consoleGame?.length ?? 0}
        </>
      ),
      icon: 'merit',
      value: 'console',
    },
  ];
  useEffect(() => {
    // 游戏搜索或没有游戏权限列表默认展开
    if (searchValue || renderGameList?.length < 1) {
      setActiveIds(['1']);
    }
  }, [searchValue, renderGameList]);
  return (
    <div className={`dbd-all-game-box ${searchValue ? 'dbd-search-game-box' : ''}`}>
      <div className="all-game">
        <Segment
          value={gameType.toString()}
          onChange={setGameType}
          options={gameTypeList}
          className="all-game-segment"
        />
      </div>
      <div className="dbd-drawer-gamelistbox">
        {/* 因为这个样式间距和别的不一样所以在这裹一层样式 */}
        <div className="gamelistbox-top-padding">
          <GameList
            namespace={namespace}
            searchValue={searchValue}
            list={renderGameList}
            noAccessGameList={renderNoAccessGameList}
            setGameModalVisible={setGameModalVisible}
            menuWidth={menuWidth}
          />
        </div>
        <Collapse
          activeIds={activeIds}
          onActive={(activeIds) => {
            setActiveIds(activeIds);
          }}
          icon={(active) => <SvgIcon className="dbd-collapse-icon" type={active ? 'point-top' : 'point-down'} />}
          iconPosition="right"
        >
          {renderNoAccessGameList?.length > 0 && (
            <Collapse.Panel id="1" title={formatMessage({ id: 'game_selector_game_no_autority' })}>
              <GameList
                namespace={namespace}
                searchValue={searchValue}
                list={renderNoAccessGameList}
                setGameModalVisible={setGameModalVisible}
                menuWidth={menuWidth}
              />
            </Collapse.Panel>
          )}
        </Collapse>
      </div>
    </div>
  );
}

export default connect((state: any, props) => {
  const { loading } = state;
  return {
    gameLoading: loading.effects[`${props.namespace}/getGameList`],
  };
})(GameTypeFilter);
